var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin",class:{ collapse: _vm.adminCollapse }},[_c('img',{attrs:{"src":require("@/assets/images/avatar.png"),"alt":""}}),_c('span',[_vm._v(_vm._s(_vm.$store.state.adminUser.userName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }